export default "__VITE_ASSET__BpbbX28i__"